'use strict';

const { MAX_LEVEL } = require('./constants');

function patternsForLevel(level) {
  if (level <= 9) return ['straight'];
  if (level <= 24) return level < 17 ? ['aimed'] : ['straight', 'aimed'];
  if (level <= 44) return level < 34 ? ['fan'] : ['aimed', 'fan'];
  if (level <= 69) return level < 56 ? ['spiral'] : ['fan', 'spiral'];
  if (level <= 89) return level < 80 ? ['cross'] : ['spiral', 'cross'];
  return ['aimed', 'fan', 'spiral', 'cross'];
}

function getLevelConfig(level) {
  const safeLevel = Math.max(1, Math.min(MAX_LEVEL, Math.floor(Number(level) || 1)));
  const baseBulletSpeed = Math.min(360, 120 + (safeLevel - 1) * 2.45);
  const baseHomingTurnRate = Math.min(1.4, 0.5 + (safeLevel - 1) * 0.0092);
  const baseSpawnInterval = Math.max(0.28, 1 - (safeLevel - 1) * 0.0074);
  const baseMaxBullets = Math.min(58, 8 + Math.floor(safeLevel * 0.52));
  return Object.freeze({
    level: safeLevel,
    duration: Math.min(45, 18 + Math.floor((safeLevel - 1) / 3)),
    bulletSpeed: baseBulletSpeed * 1.6,
    homingTurnRate: baseHomingTurnRate * 1.6,
    spawnInterval: baseSpawnInterval / 1.6,
    maxBullets: Math.round(baseMaxBullets * 1.6),
    patterns: Object.freeze(patternsForLevel(safeLevel))
  });
}

function getPlayerScale(level) {
  const safeLevel = Math.max(1, Math.min(MAX_LEVEL, Math.floor(Number(level) || 1)));
  return 0.6 + ((safeLevel - 1) * 0.9) / (MAX_LEVEL - 1);
}

module.exports = { getLevelConfig, getPlayerScale, patternsForLevel };
